import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { FR_SUFFIX } from "../../entities/Constants";
import { Checkbox } from "primereact/checkbox";
import { ConfirmDialog } from 'primereact/confirmdialog';
import Utils from "../../utilities/Utils";
import { DialogBase, Props } from "./DialogBase";

interface State {
  showConfirmationDialog: boolean;
  removeIndex: number;
}


export class DialogforTableMoreButton extends DialogBase<Props,State> {
  dateTypeFieldList = [];

  constructor(props: Props) {
    super(props);
    this.state = {
      showConfirmationDialog: false,
      removeIndex: -1,
    };
  }

  generateHtmlString = () => {
    if (this.props.ele.parent == null) {
      return null;
    }

    let parentEle = this.props.ele.parent as FormSubSections;
    this.dateTypeFieldList = parentEle.ListOfFormSectionElements?.filter(
      (p) => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence
    );

    let html = [];
    html.push(
      <>
        {/* @ts-ignore */}
        <Dialog
          header={this.props.isEng ? "Field options for " + this.props.ele.ENUTitle : "Field options for " + this.props.ele.FRATitle}
          footer={this.renderFooter()}
          visible={this.props.dialogVisible}
          style={{ width: '50vw' }}
          onHide={() => this.props.callback(false)}
        >
          {this.renderOptions()}
          {this.otherDataTypeFields()}
        </Dialog>
      </>
    );
    return html;
  }

  renderOptions = () => {
    let htmlString = [];

    htmlString.push(
      <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_table_editable" + this.props.ele.Id}>
        <div style={{width:'25%'}}><label htmlFor={'Update_table_input_editable' + this.props.ele.Id}>&nbsp;Update Binding Field&nbsp;</label></div>
        <div style={{width:'60%'}}><InputText id={'Update_table_input_editable' + this.props.ele.Id} className="ontario-input"
         value={this.props.isEng ? this.props.ele.UpdateField : this.props.ele.UpdateFieldFRA}
          onChange={(e) => {
             this.props.isEng ? this.props.ele.UpdateField = e.target.value : this.props.ele.UpdateFieldFRA = e.target.value;
             this.props.callback() }}>
        </InputText></div>

      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_table_editable" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'input_editable' + this.props.ele.ENUTitle} >&nbsp;Column Width&nbsp;</label>
        </div>
        <div style={{width:'60%'}}><InputText id={'input_editable' + this.props.ele.ENUTitle} className="ontario-input" value={this.props.ele.colWidth}
          onChange={(e) => { this.props.ele.colWidth = e.target.value;  this.props.callback() }}>
        </InputText></div>

      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', paddingTop: '10px' }} key={"chk_table_optional_" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'chk_required_' + this.props.ele.Id} style={{ marginRight: '22px' }}>&nbsp;Required&nbsp;</label>
        </div>
        <div>
          {/* @ts-ignore */}
          <Checkbox id={'chk_required_' + this.props.ele.Id} checked={this.props.ele.Optional === 'N'} 
                 onChange={(e) => { 
                  if(e.checked){
                    this.props.ele.Optional = 'N'; 
                    this.props.ele.EmptyErrorMessage = '{0} is a mandatory field';
                    this.props.ele.EmptyErrorMessageFRA = '{0} est un champ obligatoire.';
                }else{
                    this.props.ele.Optional = 'Y';
                    delete this.props.ele.EmptyErrorMessage;
                    delete this.props.ele.EmptyErrorMessageFRA;
                }
                  e.checked ? this.props.ele.Optional = 'N' : this.props.ele.Optional = 'Y'; this.props.callback() 


                 }} />
        </div>
      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', paddingTop: '10px' }} key={"chk_table_editable" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'chk_ReadOnly_editable' + this.props.ele.Id} style={{ marginRight: '12px' }}>&nbsp;Read Only&nbsp;</label>
        </div>
        <div>
          {/* @ts-ignore */}
          <Checkbox id={'chk_ReadOnly_editable' + this.props.ele.Id} checked={this.props.ele.Editable === 'N'} onChange={(e) => { e.checked ? this.props.ele.Editable = 'N' : this.props.ele.Editable = 'Y'; this.props.callback() }}></Checkbox>
        </div>
      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', paddingTop: '10px' }} key={"chk_table_allow_sorting" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'chk_allow_sorting' + this.props.ele.Id} style={{ marginRight: '12px' }}>&nbsp;Allow Sorting&nbsp;</label>
        </div>
        <div>
          {/* @ts-ignore */}
          <Checkbox id={'chk_allow_sorting' + this.props.ele.Id} checked={this.props.ele.AllowSorting === true} onChange={(e) => { this.props.ele.AllowSorting = e.checked; this.props.callback() }}></Checkbox>
        </div>
      </div>
    );

    htmlString.push(
      <div style={{ display: 'flex', paddingTop: '10px' }} key={"chk_table_is_clickable" + this.props.ele.Id}>
        <div style={{width:'25%'}}>
          <label htmlFor={'chk_is_clickable' + this.props.ele.Id} style={{ marginRight: '12px' }}>&nbsp;Is Clickable&nbsp;</label>
        </div>
        <div>
          {/* @ts-ignore */}
          <Checkbox id={'chk_is_clickable' + this.props.ele.Id} checked={this.props.ele.IsClickable === true} onChange={(e) => { this.props.ele.IsClickable = e.checked; this.props.callback() }}></Checkbox>
        </div>
      </div>
    );

    if (this.props.ele.IsClickable) {
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_click_accessibility_label" + this.props.ele.Id}>
          <div style={{ width: '25%' }}>
            <label htmlFor={'click_accessibility_label_' + this.props.ele.Id}>&nbsp;Accessibility Label&nbsp;</label>
          </div>
          <div style={{ width: '60%' }}>
            <InputText id={'click_accessibility_step_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.AccessibilityLabel?.toString() || ''}
              placeholder="e.g., Edit details for {FieldName}"
              onChange={(e) => { this.props.ele.AccessibilityLabel = e.target.value || ''; this.props.callback() }}>
            </InputText>
          </div>
        </div>
      );
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_click_url" + this.props.ele.Id}>
          <div style={{width:'25%'}}>
            <label htmlFor={'click_url_' + this.props.ele.Id}>&nbsp;Click API URL&nbsp;</label>
          </div>
          <div style={{width:'60%'}}>
            <InputText id={'click_url_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.ClickUrl || ''}
              placeholder="e.g., /api/individual/{{ehsId}}"
              onChange={(e) => { this.props.ele.ClickUrl = e.target.value; this.props.callback() }}>
            </InputText>
          </div>
        </div>
      );
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_click_next_step" + this.props.ele.Id}>
          <div style={{width:'25%'}}>
            <label htmlFor={'click_next_step_' + this.props.ele.Id}>&nbsp;Next Step Index&nbsp;</label>
          </div>
          <div style={{width:'60%'}}>
            <InputText id={'click_next_step_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.ClickNextStep?.toString() || ''}
              placeholder="e.g., 2"
              onChange={(e) => { this.props.ele.ClickNextStep = parseInt(e.target.value) || 0; this.props.callback() }}>
            </InputText>
          </div>
        </div>
      );
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_click_response_field" + this.props.ele.Id}>
          <div style={{width:'25%'}}>
            <label htmlFor={'click_response_field_' + this.props.ele.Id}>&nbsp;Response Field ID&nbsp;</label>
          </div>
          <div style={{width:'60%'}}>
            <InputText id={'click_response_field_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.ClickApiResponseField || ''}
              placeholder="e.g., individualData"
              onChange={(e) => { this.props.ele.ClickApiResponseField = e.target.value; this.props.callback() }}>
            </InputText>
          </div>
        </div>
      );
    }

    if (this.props.ele.Datatype === 'Text') {
      htmlString.push(
        this.toDisplayWhenEmptyHtml()
      );
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_max_display_length_" + this.props.ele.Id}>
          <div style={{ width: '25%' }}>
            <label htmlFor={'max_display_length_' + this.props.ele.Id}>&nbsp;Max Display Length&nbsp;</label>
          </div>
          <div style={{ width: '60%' }}>
            <InputText
              id={'max_display_length_' + this.props.ele.Id}
              className="ontario-input"
              type="number"
              placeholder="e.g., 20 — truncates with …"
              value={(this.props.ele as any).maxDisplayLength?.toString() ?? ''}
              onChange={(e) => {
                const val = parseInt(e.target.value, 10);
                (this.props.ele as any).maxDisplayLength = isNaN(val) || val <= 0 ? undefined : val;
                this.props.callback();
              }}
            />
          </div>
        </div>
      );
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_max_length_" + this.props.ele.Id}>
          <div style={{ width: '25%' }}>
            <label htmlFor={'max_length_' + this.props.ele.Id}>&nbsp;Max Length (hard cap)&nbsp;</label>
          </div>
          <div style={{ width: '60%' }}>
            <InputText
              id={'max_length_' + this.props.ele.Id}
              className="ontario-input"
              type="number"
              placeholder="e.g., 100"
              value={(this.props.ele as any).maxLength?.toString() ?? ''}
              onChange={(e) => {
                const val = parseInt(e.target.value, 10);
                (this.props.ele as any).maxLength = isNaN(val) || val <= 0 ? undefined : val;
                this.props.callback();
              }}
            />
          </div>
        </div>
      );
    }

    // Button type - Popup configuration for actions
    if (this.props.ele.Datatype === 'Button') {
      htmlString.push(
        <div style={{ display: 'flex', paddingTop: '10px' }} key={"chk_show_popup_" + this.props.ele.Id}>
          <div style={{width:'25%'}}>
            <label htmlFor={'chk_show_popup_' + this.props.ele.Id} style={{ marginRight: '12px' }}>&nbsp;Show Popup&nbsp;</label>
          </div>
          <div>
            {/* @ts-ignore */}
            <Checkbox id={'chk_show_popup_' + this.props.ele.Id} checked={this.props.ele.ShowPopup === true} onChange={(e) => { this.props.ele.ShowPopup = e.checked; this.props.callback() }}></Checkbox>
          </div>
        </div>
      );

      if (this.props.ele.ShowPopup) {
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_title_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_title_' + this.props.ele.Id}>&nbsp;Popup Title&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_title_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupTitle || ''}
                placeholder="e.g., You're about to remove an admin"
                onChange={(e) => { this.props.ele.PopupTitle = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_title_fra_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_title_fra_' + this.props.ele.Id}>&nbsp;Popup Title (FR)&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_title_fra_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupTitleFRA || ''}
                onChange={(e) => { this.props.ele.PopupTitleFRA = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_message_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_message_' + this.props.ele.Id}>&nbsp;Popup Message&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_message_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupMessage || ''}
                placeholder="e.g., Are you sure you want to remove this admin?"
                onChange={(e) => { this.props.ele.PopupMessage = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_message_fra_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_message_fra_' + this.props.ele.Id}>&nbsp;Popup Message (FR)&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_message_fra_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupMessageFRA || ''}
                onChange={(e) => { this.props.ele.PopupMessageFRA = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_save_btn_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_save_btn_' + this.props.ele.Id}>&nbsp;Confirm Button Text&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_save_btn_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupSaveButtonText || ''}
                placeholder="e.g., Remove"
                onChange={(e) => { this.props.ele.PopupSaveButtonText = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_save_btn_fra_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_save_btn_fra_' + this.props.ele.Id}>&nbsp;Confirm Button (FR)&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_save_btn_fra_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupSaveButtonTextFRA || ''}
                onChange={(e) => { this.props.ele.PopupSaveButtonTextFRA = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_cancel_btn_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_cancel_btn_' + this.props.ele.Id}>&nbsp;Cancel Button Text&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_cancel_btn_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupCancelButtonText || ''}
                placeholder="e.g., Cancel"
                onChange={(e) => { this.props.ele.PopupCancelButtonText = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_popup_cancel_btn_fra_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'popup_cancel_btn_fra_' + this.props.ele.Id}>&nbsp;Cancel Button (FR)&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'popup_cancel_btn_fra_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.PopupCancelButtonTextFRA || ''}
                onChange={(e) => { this.props.ele.PopupCancelButtonTextFRA = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
        htmlString.push(
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%', paddingTop: '10px' }} key={"input_confirm_api_" + this.props.ele.Id}>
            <div style={{width:'25%'}}>
              <label htmlFor={'confirm_api_' + this.props.ele.Id}>&nbsp;Confirm API&nbsp;</label>
            </div>
            <div style={{width:'60%'}}>
              <InputText id={'confirm_api_' + this.props.ele.Id} className="ontario-input" value={this.props.ele.ConfirmAPI || ''}
                placeholder="e.g., api/v1/admins/{{id}}"
                onChange={(e) => { this.props.ele.ConfirmAPI = e.target.value; this.props.callback() }}>
              </InputText>
            </div>
          </div>
        );
      }
    }

    htmlString.push(
      this.scriptHtml()
    );

    return htmlString;
  }

  otherDataTypeFields = () => {
    let htmlString = [];

    // Date type
    if (this.props.ele.Datatype === 'Date') {
      htmlString.push(
        this.dateCompareDisplayHtml()
      );
      htmlString.push(
        this.toDisplayWhenEmptyHtml()
      );
    }

    // Dropdown
    if (this.props.ele.Datatype === 'Dropdown') {
      htmlString.push(this.addlov());
    }

    // Checkbox
    if (this.props.ele.Datatype === 'Checkbox') {
      htmlString.push(
        <div style={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '5px', paddingTop: '15px' }} key={"chk_table_optional_" + this.props.ele.Id}>
          <div>
            {/* @ts-ignore */}
            <Checkbox
              checked={this.props.ele.MustHaveTrueValueInTable === 'Y'}
              inputId={"table_chexkbox_MustHaveTrueValueInTable" + this.props.ele.Id}
              onChange={(e) => {
                if (e.checked) {
                  this.props.ele.MustHaveTrueValueInTable = 'Y';
                } else {
                  this.props.ele.MustHaveTrueValueInTable = 'N';
                }
                this.props.callback();
              }}
            />
          </div>
          <div>
            <label style={{ paddingLeft: '5px' }} htmlFor={"table_chexkbox_MustHaveTrueValueInTable" + this.props.ele.Id}>
              {"At least one '" + this.props.ele.ENUTitle + "' must be checked"}
            </label>
          </div>
        </div>
      );
    }

    return htmlString;
  }

  addlov = () => {
    let ele = this.props.ele;
    let lovString = [];
    if (ele.ListOfLOVValues == null) {
      ele.ListOfLOVValues = [];
    }

    if (ele.ListOfLOVValues.length === 0) {
      let lov=new LOVValues();
      lov.parent=ele;
      ele.ListOfLOVValues.push();
    }

    ele.ListOfLOVValues.forEach((lov: LOVValues, index) => {
      lovString.push(
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', paddingTop: '5px', alignItems: 'center' }} key={"table_option_" + index} >
          <div style={{ marginRight: '5px' }}>{index + 1}</div>
          <div style={{ width: '70%' }}>
            <InputText
              className='ontario-input-small'
              placeholder={'Option ' + (index + 1).toString()}
              value={lov.code}
              onChange={(e) => {
                if (this.props.isEng) {
                  if(Utils.willDefaultFR(lov.description,lov.FRADescription)){
                    lov.FRADescription= Utils.isNullOrEmpty(e.target.value)? '':e.target.value+ FR_SUFFIX;
                  }
                  lov.code = e.target.value;
                  lov.description = lov.code;
                } else {
                  lov.FRA = e.target.value;
                  lov.FRADescription = e.target.value;
                }
                this.props.callback();
              }}
            ></InputText>
          </div>
          <div key={"remove_option"}>
            <i
              title="Remove me"
              className="pi pi-trash"
              style={{ fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => this.setState({ showConfirmationDialog: true, removeIndex: index })}
            ></i>
          </div>
        </div>
      );
    });

    lovString.push(
      <div key={"addoption_" + ele.Sequence}>
        <i
          style={{ border: '1px solid grey', padding: '3px 7px', borderRadius: '5px', cursor: 'pointer', marginTop: '5px' }}
          className="pi pi-plus"
          onClick={() => {
            let option = new LOVValues();
            option.parent=ele;
            option.Sequence = ele.ListOfLOVValues.length;
            ele.ListOfLOVValues.push(option);
            this.props.callback();
          }}
        ></i>
      </div>
    );

    return lovString;
  }

  renderFooter = () => {
    return (
      <div>
        {/* @ts-ignore */}
        <Button label="OK" icon="pi pi-check" onClick={() => {
          this.props.callback(false);
        }} />
        {/* @ts-ignore */}
        <Button label="Cancel" onClick={() => { this.props.callback(false) }} />
      </div>
    );
  }

  handleRemoveConfirmation = (accept: boolean) => {
    if (accept) {
      const { removeIndex } = this.state;
      const { ele, callback } = this.props;

      ele.ListOfLOVValues.splice(removeIndex, 1);
      callback();
    }

    this.setState({ showConfirmationDialog: false, removeIndex: -1 });
  };

  renderConfirmationDialog = () => {
    const { showConfirmationDialog } = this.state;

    return (
      <>
        {/* @ts-ignore */}
        <ConfirmDialog
          visible={showConfirmationDialog}
          onHide={() => this.handleRemoveConfirmation(false)}
          message="Are you sure you want to remove this?"
          header="Confirmation"
          icon="pi pi-exclamation-triangle"
          accept={() => this.handleRemoveConfirmation(true)}
          reject={() => this.setState({ showConfirmationDialog: false })}
          closable={false}
        />
      </>
    );
  };

  render() {
    return (
      <>
        {this.generateHtmlString()}
        {this.renderConfirmationDialog()}
      </>
    );
  }
}
